/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { formatNumber, formatNumberWithComma } from '../../../utilities/formatHelpers';
import { currencies, exchange } from '../../../utilities/constants';

const OfferItemLayout = ({ item, onDepositClick }) => {
  const { t: translate } = useTranslation();

  const details = (
    <button
      type="button"
      className="btn yield-btn text-f6 py-2 px-3 border-0 text-bolder"
      onClick={() => onDepositClick(item)}>
      <b>{translate('deposit_btn_label')}</b>
    </button>
  );

  return (
    <div
      className="row bg-lighter rounded-extra px-md-4 px-3 py-3 my-3 mx-0"
      role="button"
      onClick={() => onDepositClick(item)}
      onKeyDown={() => onDepositClick(item)}
      tabIndex={-1}>
      <div className="col my-auto ps-0">
        <p className="text-f4 text-bolder">{`${formatNumber(
          item?.annualizedYieldPct,
          exchange.FIAT_VALUE
        )}%`}</p>
      </div>
      <div className="col ps-0 d-md-block d-none text-nowrap my-auto">
        <p className="text-f5 text-bolder">
          {translate('yield_offer_details_modal_days_label').replace(
            '__DAYS_NUMBER__',
            item?.duration
          )}
        </p>
      </div>
      <div className="col d-md-block d-none my-auto">
        <p className="text-f5 text-bolder">
          {`${formatNumberWithComma(
            formatNumber(item?.settleCoinEffectivePurchasePrice, exchange.FIAT_VALUE)
          )} ${currencies.USDC.fullName}`}
        </p>
      </div>
      <div className="col d-md-block d-none text-end my-auto pe-0">{details}</div>
      <div className="d-md-none d-block col-6 p-0">
        <div className="d-flex flex-column align-items-end ">
          <p>{`${formatNumberWithComma(formatNumber(item?.linkedPrice, exchange.FIAT_VALUE))} ${
            currencies.USDC.fullName
          }`}</p>
          <p className="text-shadow text-f5">
            {moment(item?.expirationDate, 'YYYYMMDDh:mm:ss').format('DD/MM/YYYY')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfferItemLayout;

OfferItemLayout.propTypes = {
  item: PropTypes.object.isRequired,
  onDepositClick: PropTypes.func.isRequired,
};
